import { Component, OnInit } from '@angular/core';
import { GridApi } from 'ag-grid-community';
import { Router, ActivatedRoute } from '@angular/router';
import { AdministrationSummaryService } from 'src/app/services/administration/administration-summary.service';
import { DeleteBoxComponent } from 'src/app/common/delete-box/delete-box.component';
import { MessageBoxComponent } from 'src/app/common/message-box/message-box.component';
import { FaqModalComponent } from './faq-modal/faq-modal.component';
import { CommonCriteriaService } from 'src/app/services/common/common-criteria.service';
import { CommonService } from 'src/app/services/common.service';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { Module } from '../../models/common';
import { FAQ } from 'src/app/models/um/organization';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss']
})
export class FaqComponent implements OnInit {

  collapesedOrNot: boolean;
  gridApi: GridApi;
  columnDefs;
  operations;
  StatusList:any[] = [];
  tempoperation;
  rowData;
  formData;
  advanceSearch;
  selectedRow;
  faqForm: UntypedFormGroup;
  modules: any;
  proglist:any[] = []
  modulelist: Module[] = [];
  faq: FAQ;
  ist: string = '';
  eap: string = '';
  grants: string = '';
  isSettings:boolean=false;
  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    public route: ActivatedRoute,
    private criteriaService: CommonCriteriaService,
    private summaryService: AdministrationSummaryService,
    private modalService: NgbModal,
    private commonService: CommonService,
  ) {

  }

   ngOnInit(){
     
    this.StatusList.push({label:"All",value:"-1", 
  });
    this.StatusList.push({label:"Active",value:"1"});
    this.StatusList.push({label:"Inactive",value:"0"}); 

   



    this.collapesedOrNot = false;
    this.faqForm = new UntypedFormGroup({
      NAME: new UntypedFormControl(""),
      FAQ: new UntypedFormControl(""),
      STATUS: new UntypedFormControl("-1"),
      // Program: new UntypedFormControl(""),
      Module: new UntypedFormControl("-1"),
      IS_FOR_IST: new UntypedFormControl(false),
      IS_FOR_EAP: new UntypedFormControl(false),
      IS_FOR_GRANTS: new UntypedFormControl(false)
      
      // IS_FOR_IST : new UntypedFormGroup(),
    });

    this.columnDefs = 
    [ { "headerName": "FAQ’s ", "field": "QUESTION" }, 
      { "field": "MODULES", "headerName": "Applicable programs " },
      { "field": "tARGETuserstring", "headerName": "Target User" },
      { "field": "MappedAppTypesNames", "headerName": "Application Type" },
      { "field": "STATUS", "headerName": "Status" }];



    this.advanceSearch = { "fields": [, { "label": "FAQ", "field": "faq", "type": "text" },
        { "label": "Status", "field": "Status", "type": "dropdown" },
    {
      "label": "Program",
      "field": "Module",
      "type": "dropdown",
      "options": this.modulelist
    }] };

    // this.operations =
    
    // [ { "name": "Delete", "id": "delete" }, { "name": "Edit", "id": "edit" }, {"name": "Add New", "id": "add" } ];

    this.tempoperation = [ ];
    if(this.commonService.getScreenPermission("609","E")){
      this.isSettings=true;
    this.tempoperation.push({
      "name": "Edit",
        "id": "edit"
    });
  }
    if(this.commonService.getScreenPermission("609","D")){
      this.isSettings=true;
    this.tempoperation.push({
      "name": "Delete",
        "id": "delete"
    });
  }

  if(this.commonService.getScreenPermission("609","N")){
    this.tempoperation.push({
      "name": "Add Frequently Asked Questions",
        "id": "add"
    });
  }

    this.operations = this.tempoperation.map(operation => {  
      return operation && operation.id === 'add' ? { name: operation.name, callback: this[operation.id], self: this, disabled: 'false' } : { name: operation.name, callback: this[operation.id], self: this }
    });

    var formData = this.faqForm.value;
    this.setSearchSummary(formData);

    //this.setSummary("");
    this.getModules();
  }

  setSearchSummary(formData) {
  //  debugger
    // if(this.faqForm.controls["Status"].value != "-1"){
    // this.formData.Status = this.faqForm.controls["Status"].value == "1" ? "Active":"Inactive" ;
    // }
    // if(this.faqForm.controls["Module"].value != "-1"){
    //   this.formData.Module = this.faqForm.controls["Module"].value == "EAP" ? "2":"NULL" ;
    // }

  //  this.getModules();
  // if(this.faqForm.controls["Module"].value == "IST")
  // {
  //   this.formData = "1";
  // }
  // if(this.faqForm.controls["Module"].value == "EAP")
  // {
  //   this.formData = "2";
  // }
  // if(this.faqForm.controls["Module"].value == "GRANTS")
  // {
  //   this.formData = "3";
  // }
    // this.formData = this.faqForm.controls["Module"].value == "IST" ? "1" : "0"
    // this.formData = this.faqForm.controls["Module"].value == "EAP" ? "2" : "0"
    // this.formData = this.faqForm.controls["Module"].value == "GRANTS" ? "3": "0"
   
    if(formData["STATUS"]==null || formData["STATUS"]==undefined)
       {
         formData["STATUS"]="-1";
       }
    this.summaryService.getAdvFAQ(formData).subscribe(summary => {
      this.rowData = summary
    });
  }

  onSetGridApi(gridApi) {
    this.gridApi = gridApi;
  }

  onCallbackOperation(opr) {
    opr.callback();
  }


  getModules() {
     
    this.summaryService.getModuleByOrgId('api/common/getmodulesbyid').subscribe((result) => {
      this.modules = result;
      let len = this.modules.length;
      for (let i = 0; i < len; i++) {
        switch (this.modules[i].CODE) {
          case "IST":
            this.ist = "1";
            this.proglist.push({label:this.modules[i].NAME,value:"IST"});
            break;
          case "EAP":
            this.eap = "2";
            this.proglist.push({label:this.modules[i].NAME,value:"EAP"});
            break;
          case "GRA":
            this.grants = "3";
            this.proglist.push({label:this.modules[i].NAME,value:"GRANTS"});
            break;
        }
      }
     this.proglist =  [{label:"All",value:"-1", checked: true}].concat(this.proglist);
    });
  }

  onSelectionChanged(event) {
    this.selectedRow = this.gridApi.getSelectedRows() ? this.gridApi.getSelectedRows()[0] : null;
  }

 onRowDoubleClicked(event) {
  const ModelRef= this.modalService.open(FaqModalComponent, {
    backdrop: false,
    keyboard: false,
    windowClass:'modal-vlg right modal-right',
    animation: true
   });
   ModelRef.componentInstance.Content={
    heading: 'View',
    content: { id: this.selectedRow['ID'] }
  }
  } 

 edit(RcordData:any) {
  const modalRef = this['self'].modalService.open(FaqModalComponent, {
    backdrop: false,
    keyboard: false,
    windowClass:'modal-llg right modal-right',
    animation: true
  });
  modalRef.componentInstance.Content= {
    heading: 'Edit',
    content: { id:RcordData['ID']}
  }
  modalRef.result.then(result => {
     //this['self'].setSummary("");
     this['self'].setSearchSummary(this['self'].faqForm.value);
   })
  }

  add() {
    const modalRef = this['self'].modalService.open(FaqModalComponent, {
      backdrop: false,
      keyboard: false,
      windowClass : 'modal-llg right modal-right',
      animation: true ,
    });
    modalRef.componentInstance.Content= {
      heading: 'Add',
      content: { id: null }
    }
     modalRef.result.then(result => {
      //this['self'].setSummary("");
      this['self'].setSearchSummary(this['self'].faqForm.value);
    })
    }
    //this["self"].commonservice.SuccessBanner(summary.Message);
  //  this["self"].commonservice.ErrorBanner("You cannot delete this Product as it is associated to an application");


  delete(RcordData:any) {
   
    let id = RcordData['ID'];
    let name=RcordData['QUESTION'];
    let message="";
   const modalRef = this['self'].modalService.open(DeleteBoxComponent, {backdrop: false});
    modalRef.componentInstance.Content={ heading: '', custommessage: 'Are you sure you want to delete the FAQ ' + "'" +name + "'" + ' ?',
    ProceedButtonName:"Delete", TerminateButtonName:"Cancel"}
    modalRef.result.then(result => {
      if(result=="okclick")
      {
        this['self'].summaryService.deleteFAQ(id).subscribe(result => {
          if (result.Status === 0) {  
            //this['self'].modalRef = this['self'].modalService.show(MessageBoxComponent, { data: { heading: 'Delete', content: { heading: '', description: 'Selected Record(s) has been Deleted.' } } });
          this['self'].commonService.SuccessBanner(result.Message);
           
                  
            this['self'].setSearchSummary(this['self'].faqForm.value);
          }
          else {
           // this['self'].modalRef = this['self'].modalService.show(MessageBoxComponent, { data: { heading: 'Delete', content: { heading: '', description: result.Message } } });
           this['self'].commonService.ErrorBanner(result.Message);
          }
        });
      }
      
    })
    
  }

  // active() {
  //   this['self'].commonService.activeFeature("FAQ", this['self'].selectedRow.ID).subscribe(result => {
  //     this['self'].modalRef = this['self'].modalService.show(MessageBoxComponent, {
  //       data: { heading: 'Active', content: { heading: '', description: 'Selected Records has been made Active.' } }
  //     });
  //     //this['self'].setSummary("-1");
  //     this['self'].setSearchSummary(this['self'].faqForm.value);
  //   });
  // }

  // inactive() {
  //   //this['self'].selectedRow.org_status = "InActive";
  //   this['self'].commonService.inactiveFeature("FAQ", this['self'].selectedRow.ID).subscribe(result => {
  //     this['self'].modalRef = this['self'].modalService.show(MessageBoxComponent, {
  //       data: { heading: 'In-Active', content: { heading: '', description: 'Selected Records has been made InActive.' } }
  //     });
  //     //this['self'].setSummary("-1");
  //     this['self'].setSearchSummary(this['self'].faqForm.value);
  //   }); 
  // }

  setSummary(filter: string) {
    let strfilter = "-1";
    if (filter !== "")
      strfilter = filter;
    this.summaryService.getFAQ(strfilter).subscribe(summary => {
      this.rowData = summary
    });
  }

  setSearch() {
 
    this.SearchClear();
    this.summaryService.getAdvFAQ(this.faqForm.value).subscribe(summary => {
      this.rowData = summary
    });


  }

  //// Advace search Functions
  SearchClear() {
    
    this.faqForm = new UntypedFormGroup({
      // NAME: new UntypedFormControl(""),
      FAQ: new UntypedFormControl(""),
      STATUS: new UntypedFormControl("-1"),

      Module: new UntypedFormControl("-1"),
      // Program: new UntypedFormControl("")
    });
  }

  AdvanceSearch() {
  //  debugger
   // let formData=this.faqForm.getRawValue();
    //this.formData = this.faqForm.controls["Status"].value == 1 ? "Active":"Inactive" ;
    this.setSearchSummary(this.faqForm.value);
  }

  // let FormData=this.userForm.getRawValue();
  //  ;
  //    if(FormData["RECORD_STATE"]==null || FormData["RECORD_STATE"]==undefined)
  //    {
  //      FormData["RECORD_STATE"]=101;
  //    }
  //  this.summaryService.getUserSearchSummary(FormData).subscribe(summary => {
  //    this.rowData = summary;
  //  });

}
